import { KeyboardArrowLeft } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import Zoom from '@mui/material/Zoom';

export default function SubstepBackButton({substepBackward, firstSubstep, firstStep}){
    return (
        <div className="wrapper" id='substepBackwardWrapper'>
            <Tooltip title="Letzte Seite" TransitionComponent={Zoom} arrow>
                <IconButton
                size="small"
                onClick={substepBackward}
                disabled={firstStep && firstSubstep}
                color="primary"
                >
                    <KeyboardArrowLeft />
                </IconButton>
            </Tooltip>
        </div>
        
    )
}